import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import platformAPI from "../../../services/platformApi";
import PlatformClubsList from "./PlatformClubsList";
import PlatformPageHeader from "./PlatformPageHeader";
import { filterClinics } from "./platformClubsUtils";
import s from "./platformAdmin.module.css";

export default function PlatformTenants() {
  const location = useLocation();
  const [clinics, setClinics] = useState([]);
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState(location.state?.msg || "");
  const [query, setQuery] = useState("");

  const load = () => {
    platformAPI
      .getClinics()
      .then((r) => setClinics(r.clinics || []))
      .catch((e) =>
        setErr(e.response?.data?.error || "Ошибка загрузки клубов"),
      );
  };

  useEffect(() => {
    load();
  }, []);

  const filtered = useMemo(
    () => filterClinics(clinics, query),
    [clinics, query],
  );

  const setStatus = async (id, status) => {
    try {
      await platformAPI.updateClinicStatus(id, status);
      setMsg("Статус обновлён");
      load();
    } catch (e) {
      setErr(e.response?.data?.error || "Ошибка");
    }
  };

  const deleteClinic = async (id) => {
    if (
      !window.confirm(
        "Удалить клуб? Клуб исчезнет из списка, доступ пользователей будет заблокирован, slug освободится. Данные останутся для статистики.",
      )
    ) {
      return;
    }
    setErr("");
    setMsg("");
    try {
      await platformAPI.deleteClinic(id);
      setMsg("Клуб удалён из списка");
      load();
    } catch (e) {
      setErr(e.response?.data?.error || "Не удалось отключить клуб");
    }
  };

  return (
    <div className={s.page}>
      <PlatformPageHeader title="Клубы" />

      {msg ? <div className={s.alertSuccess}>{msg}</div> : null}
      {err ? <div className={s.alertError}>{err}</div> : null}

      <div className={s.clubsPageBody}>
        <input
          type="search"
          className={s.clubSearch}
          placeholder="Поиск клуба или владельца…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <PlatformClubsList
          clinics={filtered}
          showStatusSelect
          onStatusChange={setStatus}
          showDeleteClinicActions
          onDeleteClinic={deleteClinic}
        />
      </div>
    </div>
  );
}
